import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cigna-cfb-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {
  constructor(public router: Router) {}
  goHome() {
    this.router.navigate(['/secure/home']);
  }
}
